import route from './route';
import message from './message';
import layout from './layout';

export default {
  index: {
    whySelect: '为什么选择 Prestige 学生公寓？ ',
    whySelectDesc1: 'Prestige系列学生公寓，致力于为全球留学生打造一致的高品质住宿体验。无论你身在何处，',
    whySelectDesc2: '我们都以统一的标准化管理与贴心的服务，为你提供一个安全、舒适、温暖如家的居住环境。 ',
    footerDesc: '专为学生设计的优质生活空间，提供舒适、安全、便利的住宿环境。 ',
    copyright: '2026 PRESTIGE 32 ,保留所有权利。 ',
    advantagesTitle: '公寓优势',
    roomTypeTitle: '精致的房间',
    roomVisit: '参观房间',
    locationTitle: '优越位置',
    arriveInstitutionTime: '到校交通时间',
    arriveTransportTime: '交通时间',
    feeTitle: '费用说明',
    contactUsTitle: '预约参观或了解更多信息',
    contactUsDesc: '预约参观或了解更多资讯',
    download: '下载资料',
    address: '地址',
    phone: '电话',
    email: 'Email',
    contactUsFirstName: '名字',
    contactUsLastName: '姓氏',
    contactUsName: '姓名',
    contactUsPhone: '电话号码',
    contactUsEmail: '电子邮件',
    contactUsQuest: '您的咨询',
    contactUsSend: '发送',
    firstnamePlaceholder: '请输入您的姓氏',
    lastnamePlaceholder: '请输入您的名字',
    phonePlaceholder: '请输入您的电话号码',
    emailPlaceholder: '请输入您的电子邮件地址',
    userQuestionPlaceholder: '请输入您的问题',
    menuHome: '首页',
    menuFeatures: '设施',
    menuRoomType: '房间类型',
    menuLocation: '位置',
    menuContactUs: '联络我们',
    quickLinks: '快速链接',
    contactInformation: '联系方式',
    footerAddress: '香港科學園第一期2W大厦5楼502室',
    footerPhone: '(852)2110 3835',
  },
  route,
  message,
  ...layout,
};
